export const en = {
  CANONICAL_LOCALE: "en-US",

  "general.send": "Send",
  "general.cancel": "Cancel",
  "general.apply": "Apply",
  "general.name": "Name",
  "general.privacy": "Privacy",
  "general.recipients": "Recipients",
  "general.message": "Message",
  "general.toFilter": "Filter",
  "general.messageSingular": "message",
  "general.messagePlural": "messages",
  "general.messageSettings": "Message settings",

  "date.shortYear": "year",
  "date.shortYears": "years",
  "date.shortMonth": "month",
  "date.shortMonths": "months",
  "date.shortDay": "day",
  "date.shortDays": "days",
  "date.shortHour": "h",
  "date.shortMinute": "m",
  "date.now": "now",
  "date.today": "Today",
  "date.yesterday": "Yesterday",
  "date.start": "Start",
  "date.end": "End",

  "filter.filterByPeriod": "Filter by period",
  "filter.filterByProcess": "Filter by process",
  "filter.filterByRecipient": "Filter by participant",
  "filter.clearFilters": "Clear filters",
  "filter.filterByFlag": "Filter by flag",
  "filter.searchIn": "Search in {name}",
  "filter.numberOfactiveMessages": "{number} {sufix}",
  "filter.noMessages": "No",
  "filter.allActiveMessages": "All active messages",
  "filter.allActiveMessages.sufixForLabels": "active messages",
  "filter.allActiveMessages.sufixForLabels.singular": "active message",
  "filter.archivedMessages": "Archived only",
  "filter.archivedMessages.sufixForLabels": "archived messages",
  "filter.archivedMessages.sufixForLabels.singular": "archived message",
  "filter.allMessages": "All messages",
  "filter.allMessages.sufixForLabels": "messages",
  "filter.allMessages.sufixForLabels.singular": "message",
  "filter.messagesOpenedByMe": "Opened by me",
  "filter.messagesOpenedByMe.sufixForLabels": "opened by me",
  "filter.messagesOpenedByMe.sufixForLabels.singular": "opened by me",
  "filter.allFinilizedTasks": "Finalized tasks only",
  "filter.allFinilizedTasks.sufixForLabels": "finalized tasks",
  "filter.allFinilizedTasks.sufixForLabels.singular": "finalized task",

  "chat.messages": "Messages",
  "chat.settings": "Settings",
  "chat.chatSettings": "Chat settings",
  "chat.userNotFound": "User not found",
  "chat.typeUserName": "Type username to start searching",
  "chat.typeMessage": "Type message...",
  "chat.sendTo": "Send to...",
  "chat.optionalTitle": "Title (opcional)",
  "chat.archiveMessage": "Archive message",
  "chat.newMessage": "New messagem",
  "chat.newChat": "New chat",
  "chat.noDescriptionTitle": "{archived} {name} and {number} other",
  "chat.archivedPrefix": "(archived)",
  "chat.optional": "(optional) ",
  "chat.noOptionsAvailable": "Options are not available",
  "chat.newMessagesReceived": "You received {number} {messagePlural}",
  "chat.noFlag": "Untagged",
  "chat.flag": "Tag",
  "chat.task": "Task",
  "chat.flagFinalize": 'Finalize "{flag}"',
  "chat.finalizedPrefix": "(finalized)",

  "message.empty": "Communicate with your team!",
  "message.empty.description":
    "Write messages to ask questions to someone or with other participants",
  "message.error": "An error has occurred",
  "message.error.description":
    "Content could not be loaded. Check your connection, refresh the page, or try again in a moment.",
  "message.noResults": "No results were found",
  "message.noResults.description":
    "Change your filters or write a new message.",

  "privacy.public": "Public",
  "privacy.public.description":
    "Can be visualized by all users who have access permission to the process.",
  "privacy.participants": "Participants",
  "privacy.participants.description":
    "Sent to receivers and those who are in charge of the process",
  "privacy.private": "Private",
  "privacy.private.description": "Only sent to the chosen receivers",

  "settings.inbox": "Inbox",
  "settings.sendMessage": "Message",
  "settings.notifications": "Notification",
  "settings.dynamicMessage": "Dynamic message filter",
  "settings.dynamicMessage.description":
    "Whenever you navigate or click on a process or activity, the messages linked to them will be automatically filtered. Filters will still be applied normally",
  "settings.alwaysOpenNewMessages": "Always open new messages",
  "settings.alwaysOpenNewMessages.description":
    "When you receive new messages, their chat will automatically open in a new window.",
  "settings.pressEnterToSendMessage": "Press Enter to send message",
  "settings.pressEnterToSendMessage.description":
    "Sending messages will be available by pressing Enter.",
  "settings.receiveEmailNotifications": "Receive e-mail notifications",
  "settings.receiveEmailNotifications.description":
    "Start to receive e-mail notifications.",
  "settings.more": "More settings",

  "error.reconnectingIn": "Reconnecting in {seconds} second(s)",
  "error.reconnecting": "Reconnecting...",
  "error.connectionLost": "Connection lost",

  "profiles.manager": "Manager",
  "profiles.last-approver": "Last_Approver",
};
